import { render, staticRenderFns } from "./company_retention_percentage.vue?vue&type=template&id=5b642c57"
import script from "./company_retention_percentage.vue?vue&type=script&lang=js"
export * from "./company_retention_percentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports